export default ".svg {\n  width: 60rem;\n}\n.svg .bead {\n  cursor: pointer;\n}";